import router from "@/routes/router";
import { http } from "@/config/http";
import _ from "lodash";
import store from '../store'

const namespaced = true;

const getDefaultState = () => {
    return {
        errors: [],
        superbos_admin_access_token: null,
        user_name: null,
        user_id: null,
        is_admin: null,
        is_reviewer: null
    };
};

const state = {
    superbos_admin_access_token: localStorage.getItem("superbos_admin_access_token") || null,
    user_name: localStorage.getItem("user_name") || null,
    user_id: localStorage.getItem("user_id") || null,
    is_admin: localStorage.getItem("is_admin") == 'true' ? true : false || null,
    is_reviewer: localStorage.getItem("is_reviewer") == 'true' ? true : false || null,
};

const getters = {
    loggedIn() {
        return localStorage.getItem("superbos_admin_access_token") != null;
    },
};

const mutations = {
    setFormErrors(state, data) {
        state.errors = [];
        if (data) {
            state.errors = data.details;
        }
    },
    doLogin(state, response) {
        /* remove active store variable */
        store.state.client = "";
        store.state.claim = "";
        store.state.client_name = "";
        store.state.activeClaim = null;
        store.state.documetList = [];
        store.state.tb_step = 0;

        let contentData = response.data;
        const token = contentData.token;
        if (token) {
            localStorage.setItem("superbos_admin_access_token", token);
            localStorage.setItem("user_name", contentData.firstName + " " + contentData.lastName);
            localStorage.setItem("user_id", contentData.id);
            localStorage.setItem("is_admin", contentData.isAdmin);
            localStorage.setItem("is_reviewer", contentData.isReviewer);
            state.user_id = contentData.id;
            state.superbos_admin_access_token = token;
            state.user_name = contentData.firstName + " " + contentData.lastName;
            state.is_admin = contentData.isAdmin;
            state.is_reviewer = contentData.isReviewer;
            router.push({ name: 'home' });
        } else {

        }
    },

    doLogout(state) {
        localStorage.removeItem("superbos_admin_access_token");
        localStorage.removeItem("user_name");
        localStorage.removeItem("user_id");
        localStorage.removeItem("is_admin");
        localStorage.removeItem("is_reviewer");
        localStorage.removeItem("microsoftCode");
        state.superbos_admin_access_token = null;
        state.user_name = null;
        state.user_id = null;
        state.is_admin = null;
        state.is_reviewer = null;

        if(router.history.current.name == "reviewpage" && window.location.href && window.location.href.split('?').length > 1){
            window.location.replace('/');
        }else{
            router.push({ name: 'Login' });
        }
    },

    clearLogin(state) {
        localStorage.removeItem("superbos_admin_access_token");
        localStorage.removeItem("user_name");
        localStorage.removeItem("user_id");
        localStorage.removeItem("is_admin");
        localStorage.removeItem("is_reviewer");
        state.superbos_admin_access_token = null;
        state.user_name = null;
        state.user_id = null;
    },


};

const actions = {

    async login({ commit }, data) {
        return new Promise((resolve, reject) => {

            http
                .post("Users/authenticate", data)
                .then(response => {
                    if (response.data.error) {
                        commit(
                            "showAlert",
                            {
                                title: "Error!",
                                msg: response.data.error,
                                type: "error",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    } else {
                        commit("doLogin", response);
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },

    async setpassword({ commit }, data) {
        return new Promise((resolve, reject) => {

            http
                .post("Users/SetPassword", data)
                .then(response => {
                    if (response.data.error) {
                        commit(
                            "showAlert",
                            {
                                title: "Error!",
                                msg: response.data.error,
                                type: "error",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    } else {
                        commit("doLogin", response);
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },

    async destroyToken({ commit }) {
        commit("doLogout");
    },

};

export default {
    namespaced,
    state,
    getters,
    actions,
    mutations
};
